import { render } from "./FakeNavbar.vue?vue&type=template&id=36b14bd7&scoped=true"
import script from "./FakeNavbar.vue?vue&type=script&lang=js"
export * from "./FakeNavbar.vue?vue&type=script&lang=js"

import "./FakeNavbar.vue?vue&type=style&index=0&id=36b14bd7&scoped=true&lang=scss"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b14bd7"]])

export default __exports__